import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Divider, Dropdown, Table, Tag } from "antd";
import { IconArrowRight, IconMail, IconPhone } from "@tabler/icons-react";
import CustomInput from "../../components/input/CustomInput";
import PageHeader from "../../components/header/PageHeader";
import api from "../../api";
import { useToast } from "../../components/toast";
import DetailDrawer from "./components/DetailDrawer/index.js";

export default function Users() {
  const [showDrawer, setShowDrawer] = useState(false);
  const [data, setData] = useState([]);
  const [list, setList] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState({});
  const toast = useToast();

  // filters
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  // ---- fetch list ----
  const fetchList = async () => {
    const res = await api.get_bundles();
    // console.log("res bundles --->", res);
    if (res.status === 200) {
      setList(res?.data?.data || []);
    } else {
      toast(res?.data?.message || "Алдаа гарлаа.", "error");
    }
  };

  useEffect(() => {
    fetchList();
  }, []);

  const fetchData = useCallback(
    async ({
      page = pagination.current,
      pageSize = pagination.pageSize,
    } = {}) => {
      setLoading(true);
      const res = await api.get_users({
        page,
        limit: pageSize,
        email: email || undefined,
        phone: phone || undefined,
        role: "user",
      });
      // console.log("user ->", res);
      if (res.status === 200) {
        setData(res.data.data);
        setPagination((p) => ({
          ...p,
          current: page,
          pageSize,
          total: res?.data?.pagination?.total || 0,
        }));
      } else {
        toast(res?.data?.message || "Алдаа гарлаа", "error");
      }
      setLoading(false);
    },
    [pagination.current, pagination.pageSize, email, phone]
  );

  useEffect(() => {
    const t = setTimeout(() => {
      fetchData({ page: pagination.current, pageSize: pagination.pageSize });
    }, 300);
    return () => clearTimeout(t);
  }, [fetchData, pagination.current, pagination.pageSize, email, phone]);

  const columns = useMemo(
    () => [
      {
        title: "И-мэйл",
        dataIndex: "email",
        key: "email",
      },
      {
        title: "Нэр",
        dataIndex: "username",
        key: "username",
        render: (e) => <div>{e || "-"}</div>,
      },
      {
        title: "Утас",
        dataIndex: "phone_number",
        render: (e) => <div>{e || "-"}</div>,
      },
      {
        title: "Хэрэглэгчийн багц",
        dataIndex: "UserBundles",
        render: (bundles) => {
          if (!bundles || bundles.length === 0) return "-";

          // 🔥 active багцуудыг л үлдээнэ
          const active = bundles.filter((b) => b.status === "active");

          if (active.length === 0) return "-";

          // console.log("active -->", active);
          return (
            <div>
              {active.map((b) => (
                <Tag color={b.program === "YOGA" ? "blue" : "cyan"} key={b.id}>
                  {b.Bundle?.name || "—"}
                </Tag>
              ))}
            </div>
          );

          // return (
          //   <div>{bundles.map((b) => <Tag>{b.Bundle?.name}</Tag> || "—")}</div>
          // );
          // const names = bundles.map((b) => b.Bundle?.name || "—");
          // return <div>{names.join(", ")}</div>;
        },
      },
      {
        title: "Төлөв",
        dataIndex: "active",
        key: "active",
        render: (active) => (
          <Tag color={active ? "green" : "red"}>
            {active ? "Идэвхтэй" : "Идэвхгүй"}
          </Tag>
        ),
      },
      {
        title: "Үйлдэл",
        key: "actions",
        width: 150,
        render: (_, record) => {
          const items = (record) => [
            {
              key: "detail",
              label: (
                <span style={{ color: "black", fontSize: "13px" }}>
                  Дэлгэрэнгүй
                </span>
              ),
            },
            // record?.active && {
            //   key: "bundle",
            //   label: (
            //     <span style={{ color: "black", fontSize: "13px" }}>
            //       Багц өгөх
            //     </span>
            //   ),
            // },
            // {
            //   key: "delete",
            //   label: (
            //     <span style={{ color: "red", fontSize: "13px" }}>Устгах</span>
            //   ),
            //   // onClick: () => handleDelete(record.id),
            // },
          ];

          return (
            <Dropdown
              menu={{
                items: items(record),
                onClick: ({ key }) => {
                  if (key === "detail") {
                    // console.log("Устгах:", record);
                    setSelectedUser(record);
                    setShowDrawer(true);
                  } else if (key === "bundle") {
                    // console.log("record -->", record);
                    // console.log("detail", record);
                    // setSelectedRecord(record);
                    // setShowDrawer(true);
                  }
                },
              }}
              trigger={["click"]}
            >
              <Button variant="filled" color="default" style={{ fontSize: 12 }}>
                Үйлдэл
                <IconArrowRight size={12} />
              </Button>
            </Dropdown>
          );
        },
      },
    ],
    []
  );

  const onTableChange = (pag) => {
    fetchData({ page: pag.current, pageSize: pag.pageSize });
  };

  return (
    <>
      <PageHeader title={"Хэрэглэгчид"} />
      <div className="d-flex  mb-2 align-items-center">
        <CustomInput
          allowClear
          placeholder="И-мэйл"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          prefix={<IconMail size={16} color="#999" />}
          style={{ width: 220 }}
        />
        <Divider type="vertical" />
        <CustomInput
          allowClear
          placeholder="Утас"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          prefix={<IconPhone size={16} color="#999" />}
          style={{ width: 220 }}
        />
      </div>
      <div>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={data}
          loading={loading}
          rowHoverable={false}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showSizeChanger: true,
            pageSizeOptions: [10, 20, 50, 100],
            showTotal: (t) => `Нийт: ${t}`,
          }}
          onChange={onTableChange}
        />
      </div>

      <DetailDrawer
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
        record={selectedUser}
        list={list || []}
        trigger={() => fetchData()}
      />
    </>
  );
}
